import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PopupSelectionModel} from './models/popup-selection.model';

@Component({
  selector: 'app-popup-selection',
  templateUrl: './popup-selection.component.html',
  styleUrls: ['./popup-selection.component.scss']
})
export class PopupSelectionComponent<T> {
  popupIsOpen = false;
  chosenSelectionOption: PopupSelectionModel<T> | null = null;
  @Input() options: Array<PopupSelectionModel<T>>;
  @Input() set chosenOptionType(val: T | null) {
    if (val === null) {
      this.chosenSelectionOption = null;
    } else if (this.options) {
      this.chosenSelectionOption = this.options.find(o => o.type === val) || null;
    }
  }
  @Output() chosenOptionTypeEvent = new EventEmitter<T>();

  chosenSelection(event: PopupSelectionModel<T>) {
    this.chosenOptionTypeEvent.emit(event.type);
    this.chosenSelectionOption = event;
  }
}
